<template>
  <main class="main sp">

    <Breadcrumbs :breadcrumbs="breadcrumbs" />

    <!-- Hero -->
    <section class="sp-hero">
      <div class="container sp-hero__container">

        <div class="sp-hero__content">
          <div class="sp-hero__label">Интерьеры</div>
          <h1 class="title sp-hero__title">
            Создай атмосферное пространство для жизни
          </h1>
          <p class="sp-hero__desc">
            Интерьерные решения для дома и бизнеса
          </p>
          <button class="btn main-btn" @click="isModalOpen = true">
            Есть задача
          </button>
        </div>

        <div class="sp-hero__image">
          <img
            src="/img/services/space/hero.jpg"
            alt="Интерьерные решения для дома и бизнеса"
            loading="eager"
          />
        </div>

      </div>
    </section>

    <!-- Что предлагаем -->
    <section class="sp-offer">
      <div class="container">
        <div class="sp-offer__inner">

          <div class="sp-offer__head">
            <h2 class="title sp-offer__title">Укомплектуем интерьер под ключ</h2>
            <p class="sp-offer__desc">Тщательно отбираем партнёров, которые решат ваши задачи.</p>
          </div>

          <div class="sp-offer__grid">

            <div class="sp-offer__card sp-offer__card--wide">
              <img class="sp-offer__img" src="/img/services/space/p1.jpg" alt="Проектирование и дизайн интерьера" loading="lazy" />
              <div class="sp-offer__overlay"></div>
              <div class="sp-offer__body">
                <h3 class="sp-offer__card-title">Проектирование и дизайн интерьера</h3>
                <p class="sp-offer__card-text">Дизайнеры-партнёры разработают концепцию, визуализацию и рабочую документацию. От идеи до готового проекта.</p>
              </div>
            </div>

            <div class="sp-offer__card sp-offer__card--p2">
              <img class="sp-offer__img" src="/img/services/space/p2.jpg" alt="Товары для оснащения интерьера" loading="lazy" />
              <div class="sp-offer__overlay"></div>
              <div class="sp-offer__body">
                <h3 class="sp-offer__card-title">Товары для оснащения интерьера</h3>
                <p class="sp-offer__card-text">Мебель, освещение, сантехника, декор. Отобранные поставщики с подтверждённым качеством.</p>
              </div>
            </div>

            <div class="sp-offer__card sp-offer__card--p3">
              <img class="sp-offer__img" src="/img/services/space/p3.jpg" alt="Услуги на заказ" loading="lazy" />
              <div class="sp-offer__overlay"></div>
              <div class="sp-offer__body">
                <h3 class="sp-offer__card-title">Услуги на заказ</h3>
                <p class="sp-offer__card-text">Гардеробные, кухни, геотермальное отопление и другие решения под ваш проект — от проверенных партнёров.</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <!-- Философия -->
    <section class="sp-phil">
      <div class="container sp-phil__container">

        <div class="sp-phil__text">
          <div class="sp-phil__label">Философия</div>
          <h2 class="title sp-phil__title">Мы не магазин. Мы среда.</h2>
          <div class="sp-phil__body">
            <p>Большинство платформ показывают товары. Мы показываем, как они живут в пространстве.</p>
            <p>Каждый партнёр в нашем каталоге — это не просто поставщик. Это соавтор среды, в которой живут наши клиенты. Поэтому мы отбираем тщательно — смотрим на качество, эстетику и то, как продукт вписывается в образ жизни нашей аудитории.</p>
            <p class="sp-phil__conclusion">Наш клиент не ищет подешевле. Он решает задачу — создать пространство, в котором хочется жить, работать или принимать гостей. Именно для таких людей мы собираем каталог.</p>
          </div>
        </div>

        <div class="sp-phil__image">
          <img
            src="/img/services/space/philosophy.jpg"
            alt="Философия Шарунстор — среда, а не магазин"
            loading="lazy"
          />
        </div>

      </div>
    </section>

    <!-- Услуги партнёров -->
    <section class="sp-services">
      <div class="container">
        <h2 class="title sp-services__title">Решения под ключ от партнёров платформы</h2>
        <p class="sp-services__desc">Архитектура, перегородки, гардеробные и другие услуги — каждая со своим лендингом и проверенным партнёром.</p>

        <Swiper
          v-if="services.length"
          :modules="[SwiperNavigation]"
          :slides-per-view="1.2"
          :space-between="20"
          :navigation="true"
          :breakpoints="{
            640:  { slidesPerView: 2.2, spaceBetween: 20 },
            1024: { slidesPerView: 3,   spaceBetween: 24 },
          }"
          class="sp-services__swiper"
        >
          <SwiperSlide v-for="service in services" :key="service.id">
            <NuxtLink :to="`/product/${service.id}`" class="sp-services__card">
              <div class="sp-services__card-img">
                <img
                  v-if="service.mainImage"
                  :src="service.mainImage.path"
                  :alt="service.name"
                  loading="lazy"
                />
                <div v-else class="sp-services__card-placeholder" />
              </div>
              <div class="sp-services__card-body">
                <h3 class="sp-services__card-name">{{ service.name }}</h3>
              </div>
            </NuxtLink>
          </SwiperSlide>
        </Swiper>

        <p v-else class="sp-services__empty">Услуги появятся в ближайшее время.</p>
      </div>
    </section>

    <!-- Оффер для партнёров -->
    <section class="sp-partners">
      <div class="sp-partners__bg" aria-hidden="true"></div>
      <div class="container sp-partners__inner">

        <div class="sp-partners__label">Партнёрам</div>
        <h2 class="title sp-partners__title">Разместите товары и услуги на нашей платформе</h2>
        <p class="sp-partners__desc">Мы не маркетплейс с тысячами позиций. Мы редакция — отбираем партнёров, чьи продукты соответствуют нашей аудитории и её образу жизни.</p>

        <div class="sp-partners__theses">

          <div class="sp-partners__thesis">
            <div class="sp-partners__thesis-title">Аудитория с запросом</div>
            <p class="sp-partners__thesis-text">Люди, которые осознанно создают пространство вокруг себя. Они не ищут подешевле — они решают задачу.</p>
          </div>

          <div class="sp-partners__thesis">
            <div class="sp-partners__thesis-title">Ваш продукт в контексте</div>
            <p class="sp-partners__thesis-text">Товар или услуга подаётся не в каталожной сетке, а в среде — через вайбы, редакционные подборки и лендинги.</p>
          </div>

          <div class="sp-partners__thesis">
            <div class="sp-partners__thesis-title">Вы управляете витриной сами</div>
            <p class="sp-partners__thesis-text">Партнёр самостоятельно размещает товары, обновляет каталог и управляет своей страницей через личный кабинет.</p>
          </div>

        </div>

        <button class="sp-partners__cta" @click="isPartnerModalOpen = true">
          Стать партнёром
        </button>

      </div>
    </section>

    <!-- FAQ -->
    <section class="sp-faq">
      <div class="container sp-faq__container">
        <h2 class="title sp-faq__title">Часто задаваемые вопросы</h2>
        <div class="sp-faq__list">
          <div
            v-for="(item, i) in faq"
            :key="i"
            class="sp-faq__item"
            :class="{ 'sp-faq__item--open': openFaq === i }"
          >
            <button class="sp-faq__question" @click="openFaq = openFaq === i ? null : i">
              <span>{{ item.q }}</span>
              <svg class="sp-faq__icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </button>
            <div class="sp-faq__answer">
              <div class="sp-faq__answer-inner">{{ item.a }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </main>

  <ClientOnly>
    <teleport to="body">
      <FormSpace v-if="isModalOpen" @close="isModalOpen = false" />
      <FormSpacePartner v-if="isPartnerModalOpen" @close="isPartnerModalOpen = false" />
      <Cookie />
    </teleport>
  </ClientOnly>
</template>

<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation as SwiperNavigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import Breadcrumbs from '~/components/Section/Breadcrumbs.vue'
import FormSpace from '~/components/Modals/FormSpace.vue'
import FormSpacePartner from '~/components/Modals/FormSpacePartner.vue'
import Cookie from '~/components/Section/Cookie.vue'

const isModalOpen = ref(false)
const isPartnerModalOpen = ref(false)
const openFaq = ref(null)

const faq = [
  {
    q: 'Кто может стать партнёром?',
    a: 'Крупные производители и официальные дилеры. Не работаем с перекупщиками без подтверждённого статуса.'
  },
  {
    q: 'Какие требования к контенту?',
    a: 'Фото должны быть чёткими с естественной цветокоррекцией. AI-контент не принимается, кроме случаев передачи атмосферы пространства.'
  },
  {
    q: 'А если у нас нет контента?',
    a: 'Готовы создать его для вас на привлекательных условиях. Напишите об этом в заявке.'
  },
  {
    q: 'Кто обеспечивает логистику?',
    a: 'Комбинированная система. Чаще передаём задачу поставщику, но можем взять её решение на себя.'
  },
  {
    q: 'Как партнёр управляет своими товарами?',
    a: 'Через личный кабинет самостоятельно, без участия нашей команды.'
  },
  {
    q: 'Сколько стоит размещение?',
    a: 'Условия обсуждаются индивидуально. Оставьте заявку — менеджер свяжется и расскажет подробнее.'
  },
  {
    q: 'Как вы отбираете товары и партнёров?',
    a: 'Смотрим на качество продукта, эстетику и соответствие образу жизни аудитории. Если не проходит фильтр — размещение невозможно.'
  },
  {
    q: 'Как покупатель находит нужный товар?',
    a: 'Через каталог, вайбы и тематические подборки. Товар появляется в контексте образа жизни, а не просто в сетке категорий.'
  },
]

const config = useRuntimeConfig()
const apiBase = config.public.apiDomain

const { data: servicesRes } = await useFetch(
  `${apiBase}/products/index?taxonomyId[]=27&active=1&images=1&cc=1&limit=20`
)
const services = computed(() => servicesRes.value?.data?.products ?? [])

useHead({
  title: 'Интерьерные решения для дома и бизнеса | Шарунстор',
  meta: [
    {
      name: 'description',
      content: 'Создайте атмосферное пространство для жизни. Интерьерные решения для дома и бизнеса — подбор, проектирование, реализация.'
    }
  ]
})

const breadcrumbs = [
  { title: 'Главная', url: '/' },
  { title: 'Интерьеры' }
]
</script>

<style scoped lang="scss">
$dark: #1B1918;
$grey: #666;
$mobile: 48em;
$tablet: 75em;

// ─── Hero ─────────────────────────────────────────────────────────────────────
.sp-hero {
  padding: 6rem 0 8rem;

  &__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6rem;
    align-items: center;

    @media (max-width: $tablet) {
      grid-template-columns: 1fr;
      gap: 4rem;
    }
  }

  &__label {
    font-size: 1.2rem;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: rgba(27, 25, 24, 0.4);
    margin-bottom: 2.4rem;
  }

  &__title {
    font-size: 5rem;
    line-height: 1.1;
    margin-bottom: 2.4rem;
    color: $dark;

    @media (max-width: $tablet) {
      font-size: 4rem;
    }

    @media (max-width: $mobile) {
      font-size: 3.2rem;
    }
  }

  &__desc {
    font-size: 1.8rem;
    line-height: 1.6;
    color: $grey;
    margin-bottom: 3.6rem;
    max-width: 48rem;
  }

  &__image {
    @media (max-width: $tablet) {
      order: -1;
    }

    img {
      width: 100%;
      height: 62rem;
      object-fit: cover;
      border-radius: 0.4rem;
      display: block;

      @media (max-width: $tablet) {
        height: 44rem;
      }

      @media (max-width: $mobile) {
        height: 28rem;
      }
    }
  }
}

// ─── Услуги партнёров ─────────────────────────────────────────────────────────
.sp-services {
  padding: 10rem 0 12rem;
  background: #f7f7f7;

  &__title {
    text-align: center;
    margin-bottom: 1.6rem;
  }

  &__desc {
    text-align: center;
    font-size: 1.6rem;
    color: $grey;
    line-height: 1.6;
    max-width: 60rem;
    margin: 0 auto 5.6rem;
  }

  &__swiper {
    overflow: visible;
    padding-bottom: 0.4rem;
  }

  :deep(.sp-services__swiper .swiper-button-prev),
  :deep(.sp-services__swiper .swiper-button-next) {
    top: 35%;
    color: $dark;
  }

  :deep(.sp-services__swiper .swiper-button-prev::after),
  :deep(.sp-services__swiper .swiper-button-next::after) {
    font-size: 1.6rem;
  }

  &__card {
    display: block;
    color: inherit;
    text-decoration: none;
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    transition: box-shadow 0.2s;

    &:hover {
      box-shadow: 0 6px 24px rgba(27, 25, 24, 0.08);
    }

    &:hover &-img img {
      transform: scale(1.03);
    }
  }

  &__card-img {
    overflow: hidden;
    aspect-ratio: 4 / 3;
    background: #ebebeb;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition: transform 0.4s ease;
    }
  }

  &__card-placeholder {
    width: 100%;
    height: 100%;
    background: #e8e8e8;
  }

  &__card-body {
    padding: 2rem 2.4rem 2.4rem;
  }

  &__card-name {
    font-size: 1.7rem;
    font-weight: 700;
    color: $dark;
    line-height: 1.3;
    margin-bottom: 0.8rem;
    transition: opacity 0.2s;

    .sp-services__card:hover & {
      opacity: 0.75;
    }
  }

  &__card-text {
    font-size: 1.4rem;
    color: $grey;
    line-height: 1.6;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__empty {
    text-align: center;
    font-size: 1.6rem;
    color: #aaa;
    padding: 4rem 0;
  }
}

// ─── Оффер для партнёров ──────────────────────────────────────────────────────
.sp-partners {
  position: relative;
  padding: 12rem 0;
  overflow: hidden;

  &__bg {
    position: absolute;
    inset: 0;
    background: url('/img/services/space/for-partners.jpg') center / cover no-repeat;
    z-index: 0;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background: rgba(27, 25, 24, 0.8);
    }
  }

  &__inner {
    position: relative;
    z-index: 1;
  }

  &__label {
    font-size: 1.2rem;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.35);
    margin-bottom: 2.4rem;
  }

  &__title {
    color: #fff;
    font-size: 4.8rem;
    max-width: 72rem;
    margin-bottom: 2.4rem;
    line-height: 1.1;

    @media (max-width: $tablet) { font-size: 3.8rem; }
    @media (max-width: $mobile) { font-size: 3rem; }
  }

  &__desc {
    font-size: 1.8rem;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.65;
    max-width: 58rem;
    margin-bottom: 6.4rem;
  }

  &__theses {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 4rem;
    margin-bottom: 6.4rem;

    @media (max-width: $tablet) {
      grid-template-columns: 1fr;
      gap: 3.2rem;
    }
  }

  &__thesis {
    border-top: 1px solid rgba(255, 255, 255, 0.14);
    padding-top: 2.4rem;
  }

  &__thesis-title {
    font-size: 1.6rem;
    font-weight: 700;
    color: #fff;
    margin-bottom: 1.2rem;
  }

  &__thesis-text {
    font-size: 1.5rem;
    color: rgba(255, 255, 255, 0.55);
    line-height: 1.7;
  }

  &__cta {
    display: inline-block;
    padding: 1.6rem 4rem;
    background: #fff;
    color: $dark;
    border: none;
    border-radius: 2px;
    font-size: 1.4rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover { opacity: 0.88; }
  }
}

// ─── Философия ────────────────────────────────────────────────────────────────
.sp-phil {
  padding: 10rem 0;

  &__container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8rem;
    align-items: center;

    @media (max-width: $tablet) {
      grid-template-columns: 1fr;
      gap: 4.8rem;
    }
  }

  &__label {
    font-size: 1.2rem;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: rgba(27, 25, 24, 0.35);
    margin-bottom: 2.4rem;
  }

  &__title {
    margin-bottom: 3.2rem;
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 1.8rem;

    p {
      font-size: 1.7rem;
      line-height: 1.7;
      color: $grey;
    }
  }

  &__conclusion {
    font-size: 1.7rem;
    line-height: 1.6;
    color: $dark !important;
    font-style: italic;
    padding-top: 0.8rem;
    border-top: 1px solid rgba(27, 25, 24, 0.1);
    margin-top: 0.4rem;
  }

  &__image {
    @media (max-width: $tablet) {
      order: -1;
    }

    img {
      width: 100%;
      height: 64rem;
      object-fit: cover;
      border-radius: 0.4rem;
      display: block;

      @media (max-width: $tablet) {
        height: 44rem;
      }

      @media (max-width: $mobile) {
        height: 30rem;
      }
    }
  }
}

// ─── FAQ ──────────────────────────────────────────────────────────────────────
.sp-faq {
  padding: 10rem 0 12rem;
  background: #f7f7f7;

  &__container {
    max-width: 80rem;
    margin: 0 auto;
  }

  &__title {
    text-align: center;
    margin-bottom: 5.6rem;
  }

  &__list {
    display: flex;
    flex-direction: column;
  }

  &__item {
    border-top: 1px solid rgba(27, 25, 24, 0.1);

    &:last-child {
      border-bottom: 1px solid rgba(27, 25, 24, 0.1);
    }
  }

  &__question {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
    padding: 2.4rem 0;
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    font-family: inherit;
    font-size: 1.7rem;
    font-weight: 500;
    color: $dark;
    line-height: 1.4;
    transition: opacity 0.2s;

    &:hover { opacity: 0.7; }
  }

  &__icon {
    flex-shrink: 0;
    transition: transform 0.3s ease;
    color: $dark;
    opacity: 0.5;

    .sp-faq__item--open & {
      transform: rotate(180deg);
      opacity: 1;
    }
  }

  &__answer {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.35s ease;

    .sp-faq__item--open & {
      max-height: 40rem;
    }
  }

  &__answer-inner {
    padding-bottom: 2.8rem;
    font-size: 1.6rem;
    line-height: 1.7;
    color: $grey;
  }
}

// ─── Что предлагаем ───────────────────────────────────────────────────────────
.sp-offer {
  padding: 10rem 0 12rem;

  &__inner {
    max-width: 70%;
    margin: 0 auto;

    @media (max-width: $tablet) {
      max-width: 100%;
    }
  }

  &__head {
    text-align: center;
    margin-bottom: 4.8rem;
  }

  &__title {
    margin-bottom: 1.6rem;
  }

  &__desc {
    font-size: 1.6rem;
    color: $grey;
    line-height: 1.6;
  }

  &__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;

    @media (max-width: $mobile) {
      grid-template-columns: 1fr;
    }
  }

  &__card {
    position: relative;
    overflow: hidden;
    border-radius: 0.4rem;

    &--wide {
      grid-column: 1 / -1;
      aspect-ratio: 16 / 9;

      @media (max-width: $mobile) {
        aspect-ratio: 4 / 3;
      }
    }

    &--p2 {
      aspect-ratio: 3 / 4;
    }

    &--p3 {
      aspect-ratio: 4 / 5;
    }
  }

  &__img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.5s ease;

    .sp-offer__card:hover & {
      transform: scale(1.03);
    }
  }

  &__overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      to top,
      rgba(27, 25, 24, 0.78) 0%,
      rgba(27, 25, 24, 0.18) 45%,
      rgba(27, 25, 24, 0) 70%
    );
    z-index: 1;
  }

  &__body {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 2.8rem 3.2rem;
    z-index: 2;

    @media (max-width: $mobile) {
      padding: 2rem 2.4rem;
    }
  }

  &__card-title {
    font-size: 1.9rem;
    font-weight: 600;
    color: #fff;
    line-height: 1.3;
    margin-bottom: 0.8rem;
  }

  &__card-text {
    font-size: 1.4rem;
    color: rgba(255, 255, 255, 0.65);
    line-height: 1.6;
  }
}
</style>
